import React from "react";

const DockRightDoubleColumn = ({ style = {} }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 16" style={style}>
            <g>
                <g id="dock-left">
                    <path
                        id="dock-left-2"
                        class="cls-1"
                        d="M2,16h16c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2H2C.9,0,0,.9,0,2v12c0,1.1.9,2,2,2M2,2h5.5v12H2V2ZM13,2h1.2v12h-1.2V2Z" fill="#fff"
                    />
                </g>
            </g>
        </svg>
    );
};

export default DockRightDoubleColumn;
